module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"src/assets/image/CDCSR_logotype-coul_seul (1)-1.png"},
    }]
